import { render, staticRenderFns } from "./TariffCode.vue?vue&type=template&id=097d454a&"
import script from "./TariffCode.vue?vue&type=script&lang=js&"
export * from "./TariffCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports